const Footer = () => {
    return (
      <footer className="footer">
        <p>
          Copyright &copy; {new Date().getFullYear()} <span style={{fontWeight:700}}>Twinscoder</span> All rights reserved.
        </p>
      </footer>
    );
  };
  
  export default Footer;